import { render, staticRenderFns } from "./mobile_CasePresentation.vue?vue&type=template&id=4a50dd2c&scoped=true"
import script from "./mobile_CasePresentation.vue?vue&type=script&lang=js"
export * from "./mobile_CasePresentation.vue?vue&type=script&lang=js"
import style0 from "./mobile_CasePresentation.vue?vue&type=style&index=0&id=4a50dd2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a50dd2c",
  null
  
)

export default component.exports